export default __webpack_public_path__ + "static/media/2012.d25b2b7f.png";